import { Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NewPurchaseFormTsService } from '../../service/new-purchase-form.ts.service';
import { RegistrationData } from '../../../model/RegistrationData';
import { Router } from '@angular/router';
import { generateRefId } from '../../../../../common/refid-utils';
import { HeaderComponent } from '../../main/header/header.component';

@Component({
  selector: 'app-payment',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, HeaderComponent],
  templateUrl: './payment.component.html',
  styleUrl: './payment.component.scss'
})


export class PaymentComponent {
  cardPaymentDisabled = true;
  refNumber: string = generateRefId();
  form = new FormGroup({
    paymentMethod: new FormControl('bankTraksfer'),
    cardNumber: new FormControl(''),
    cardOwner: new FormControl(''),
    cardExpiryDate: new FormControl(''),
    cardCvv: new FormControl('')
  });
  paymentInProgress = false;
  private registrationFormData: RegistrationData = {};

  constructor(
    private readonly router: Router,
    private readonly newPurchaseFormTsService: NewPurchaseFormTsService
  ) {
    this.newPurchaseFormTsService.currentFormData.subscribe(data => {
      if (data) {
        this.registrationFormData = data;
        console.log(`Received data: ${JSON.stringify(this.registrationFormData, null, 2)}`);
        this.form.patchValue({
          ...this.registrationFormData
        });
      }
    });
  }

  async proceedWithBankTransfer() {
    this.proceedWithPayment('bankTransfer');
  }

  async proceedWithCC() {
    this.proceedWithPayment('creditCard');
  }

  async proceedWithPayment(paymentMethod: string) {
    this.paymentInProgress = true;
    try {
      this.form.value.paymentMethod = paymentMethod;
      const registrationData = {
        ...this.registrationFormData,
        ...this.form.value
      };
      const registerStatus = await this.newPurchaseFormTsService.proceedWithPayment({
          email: registrationData.email || '',
          password: registrationData.password || '',
          passwordRepeat: registrationData.passwordRepeat || '',
          username: registrationData.username || '',
          phone: registrationData.phone || '',
          productId: registrationData.productId || '',
          productName: registrationData.productName || '',
          productPrice: registrationData.productPrice || 0,
          productPriceCurrency: registrationData.productPriceCurrency || '?',
          company: registrationData.company || '',
          nip: registrationData.nip || '',
          street: registrationData.street || '',
          city: registrationData.city || '',
          country: registrationData.country || '',
          zip: registrationData.zip || '',
          paymentMethod: registrationData.paymentMethod || '',
          refNumber: this.refNumber
        }
      );
      console.info(`registerStatus: ${JSON.stringify(registerStatus)}`);
      if (registerStatus.status === 'error') {
        console.error(registerStatus.message);
      } else {
        if (registerStatus.url) {
          console.log(`Proceeding with credit card payment for ${registrationData.email}`);
          setTimeout(() => {
            this.paymentInProgress = false;
            window.location.href = registerStatus.url!;
          }, 0);
        } else {
          console.log(`Proceeding with bank transfer payment for ${registrationData.email}`);
          await this.router.navigate(['/']);
        }
      }
    } finally {
      this.paymentInProgress = paymentMethod !== 'creditCard';
    }
  }

  async resetToRegister() {
    console.log('Resetting to register');
    await this.router.navigate(['/register']);
  }

}
